import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  acceptTermCheckCss,
  bulletPointsCss,
} from "./AcceptChangeSchoolTerm.style";

const propTypes = {
  /**
   * Term accept state
   */
  isChecked: PropTypes.bool,
  /**
   * Function to set the term accept state
   */
  setChecked: PropTypes.func.isRequired,
};

const AcceptChangeSchoolTerm = ({ isChecked = false, setChecked }) => {
  return (
    <>
      <h3>You'll lose access to your current school.</h3>
      <p>Including:</p>
      <ul css={bulletPointsCss}>
        <li>All associated classes</li>
        <li>Class and student data</li>
        <li>Status as a faculty member</li>
      </ul>
      <Checkbox
        __cssFor={acceptTermCheckCss}
        checked={isChecked}
        label={"I acknowledge I'll lose access to my current school."}
        onClick={() => setChecked(!isChecked)}
      />
    </>
  );
};

AcceptChangeSchoolTerm.propTypes = propTypes;

export default AcceptChangeSchoolTerm;
